module.exports = __webpack_public_path__ + "img/saas-analysis.e0c807e2.svg";